<template src="./Dynamics.html"></template>

<script>
import topMenu from '@/components/brand/components/topMenu';
import Chart from '@/components/brand/dynamics/components/Chart';
import brandSelect from '@/components/components/BrandSelect';
import {createNamespacedHelpers} from 'vuex';

const {mapGetters, mapActions} = createNamespacedHelpers('brand/dynamics')

export default {
  name: "BrandDynamics",
  components: {
    topMenu,
    Chart,
    brandSelect
  },
  data() {
    return {
      brandId: this.$route.params.id,
      showOverlay: false,
      contentStyle: {
        height: '830px'
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            gridLines: {
              display: true
            },
          }]
        }
      },
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA'
    ]),
    brandsChange: function (brand) {
      if (brand == null || (this.CURRENT_BRAND != null && this.CURRENT_BRAND.id == brand.id)) {
        return
      }
      this.brandId = brand.saleId.toString()
      this.$store.commit('brand/semantics/CURRENT_BRAND', brand);
      this.GET_DATA({id: this.brandId, th: this});
    },
    save: function () {
      this.SAVE({th: this});
    },
    heightContent: function () {
      let topMargin = 100;
      this.contentStyle.height = (window.innerHeight - topMargin) + 'px';
    },
  },
  computed: {
    ...mapGetters([
      'CHART_DATA',
      'CURRENT_BRAND',
    ]),
    chartStyles () {
      return {
        height: '300px',
        position: 'relative'
      }
    },
    getPartChartData: function () {
      let data = [];
      let partData = [];
      let counter = 0;
      for (let key in this.CHART_DATA) {
        partData.push(this.CHART_DATA[key]);
        counter++;
        partData
        if (counter >= 1) {
          data.push(partData);
          counter = 0;
          partData = [];
        }
      }
      if (partData.length > 0 && counter < 3 && counter != 0) {
        data.push(partData);
      }

      return data;
    }
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('brand') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
  },
  created() {
    if (this.CHART_DATA.length == 0 || this.CURRENT_BRAND.id != this.brandId) {
      this.GET_DATA({id: this.brandId, th: this});
    }
    this.heightContent();
  }
}
</script>

<style scoped>
.scroll-box {
  overflow-y: auto;
  margin-right: -25px;
}

</style>

<style>

</style>